import { FC, useEffect, useRef } from 'react'
import { StyleFormWrapper, StyleLabel } from '../style'
import {
  StyleButtonWrapper,
  StyleButton,
  StyleCanvasWrapper,
  StyleCanvasBg,
  StyleSignatureImageWrapper,
  StyleSignatureImage,
} from './style'
import ErrorMessage from '../ErrorMessage'
import { Field } from 'formik'
import SignatureCanvas from 'react-signature-canvas'
interface SignatureProps {
  label?: string
  name: string
  disabled?: boolean
}
const Signature: FC<SignatureProps> = ({ name, label }) => {
  const sigRef = useRef<any>(null)
  return (
    <Field name={name}>
      {({ field, meta, form }) => {
        const hasError = meta.touched && meta.error
        return (
          <StyleFormWrapper>
            {!!label && <StyleLabel hasError={hasError}>{label}</StyleLabel>}

            <StyleCanvasWrapper hasError={hasError}>
              <StyleCanvasBg>
                <SignatureCanvas
                  ref={sigRef}
                  penColor="black"
                  canvasProps={{
                    width: 350,
                    height: 250,
                    className: 'sigCanvas',
                  }}
                  onEnd={() => {
                    try {
                      const base64String =
                        sigRef?.current?.toDataURL?.('image/png')
                      if (!!base64String) {
                        const splitBase64 = base64String.split(',')
                        const base64 = splitBase64[1]
                        const info = splitBase64[0]
                        form.setFieldValue(name, {
                          extension: 'png',
                          base64,
                          info,
                        })
                      }
                    } catch (err) {
                      console.log(err)
                    }
                  }}
                />
              </StyleCanvasBg>
              <StyleSignatureImageWrapper>
                <StyleSignatureImage
                  src={
                    field?.value?.base64
                      ? `${field?.value?.info},${field?.value?.base64}`
                      : `${process.env.BUCKET_URL}/${field?.value}`
                  }
                />
              </StyleSignatureImageWrapper>
            </StyleCanvasWrapper>

            {!!hasError && <ErrorMessage message={meta.error} />}
          </StyleFormWrapper>
        )
      }}
    </Field>
  )
}

export default Signature
